// Components
import Svg from '../Components/shared/Svg'

export const HeartSvg = props => (
  <Svg
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.00337 15.6896C8.23035 15.6896 8.45093 15.6096 8.62195 15.4626C9.26771 14.9127 9.89109 14.3948 10.4393 13.9393L10.4425 13.9377C12.0537 12.5998 13.4443 11.4458 14.4114 10.3077C15.4935 9.03541 15.997 7.83021 15.997 6.51313C15.997 5.23281 15.5462 4.05319 14.7294 3.18845C13.9015 2.31413 12.7666 1.83301 11.531 1.83301C10.6088 1.83301 9.76321 2.11752 9.01836 2.67696C8.64273 2.95988 8.30227 3.30673 8.00337 3.70953C7.70287 3.30514 7.36401 2.95988 6.98839 2.67696C6.24353 2.11752 5.39958 1.83461 4.4757 1.83461C3.24173 1.83461 2.10527 2.31573 1.2773 3.19005C0.458917 4.05479 0.00976562 5.23441 0.00976562 6.51473C0.00976562 7.83181 0.513262 9.037 1.59538 10.3093C2.56241 11.4474 3.95462 12.6014 5.56421 13.9393C6.11406 14.3964 6.73904 14.9143 7.38479 15.4658C7.55582 15.6096 7.7764 15.6896 8.00337 15.6896Z'
      fill='var(--brand-neutral-warm-500)'
    />
  </Svg>
)
